export default __webpack_public_path__ + "static/FReg-Goal2-0df9638f013c4e9b2542f7b7c15395ed.jpg";